// extracted by mini-css-extract-plugin
module.exports = {"button":"RelatedLinksBlock_button__8K6Pm"};